<template>
  <div class="borrwingClass">
    <span class="sampleTypeClass">样品返还流程</span>
    <div v-html="contentObj.content"></div>  </div>
</template>

<script>
export default {
   data(){
    return{
       contentObj:{}
    }
  },
  mounted(){
    this.initDataFunc()
  },
  methods:{
    async initDataFunc(){
        let res = await this.$http.get(this.$const.moonSample.sampleAboutUS+`?pageNum=1&pageSize=10&type=2`);
        if (res && res.code==200) {
          if(res.data.length> 0){
             res.data.forEach(element => {
                if(element.title == '样品返还流程'){
                  this.contentObj = element
                }
              });
            }
        }
      },
  }
}
</script>

<style lang="scss" scoped>
.borrwingClass{
  width: 1200px;
  .sampleTypeClass{
    height: 80px;
    font-style: normal;
    display: block;
    line-height: 80px;
    font-family: MicrosoftYaHeiUISemibold;
    font-size: 28px;
    color: #000000;
    text-align: left;
    font-style: normal;
    width: 1000px;
  }
}
</style>
<style>
 .borrwingClass p img{
    width: 100%;
  }
</style>